export const SMS_OPT_OUT_POLICY_HINT_TEXT =
  'Decides if "Reply UNSUB to unsub" is added to SMSes sent to active Members / NACs. Unsub instructions will always be shown to Prospects.';
